import * as React from 'react'

function IconLinkDisabled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={90}
      height={90}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.04 35.77c5.93 5.93 5.93 15.55 0 21.48L32.43 78.86c-5.93 5.93-15.55 5.93-21.48 0s-5.93-15.55 0-21.48l6.47-6.47"
        stroke="#C4C4C4"
        strokeWidth={13}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M35.77 54.04c-5.93-5.93-5.93-15.55 0-21.48l21.61-21.61c5.93-5.93 15.55-5.93 21.48 0s5.93 15.55 0 21.48l-6.47 6.47"
        stroke="#C4C4C4"
        strokeWidth={13}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconLinkDisabled
